import { render, staticRenderFns } from "./Welfare.vue?vue&type=template&id=9b384822&scoped=true"
import script from "./Welfare.vue?vue&type=script&lang=js"
export * from "./Welfare.vue?vue&type=script&lang=js"
import style0 from "./Welfare.vue?vue&type=style&index=0&id=9b384822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b384822",
  null
  
)

export default component.exports